/**
 * Currency formatting utilities
 * Formats amounts in Indian Rupees (₹) with proper locale formatting
 */

/**
 * Format currency in Indian Rupees (₹)
 * Uses Indian number formatting (en-IN) with 2 decimal places
 * 
 * @param amount - The amount to format
 * @returns Formatted currency string (e.g., "₹1,23,456.78")
 * 
 * @example
 * formatCurrency(123456.78) // "₹1,23,456.78"
 * formatCurrency(0) // "₹0.00"
 * formatCurrency(1000) // "₹1,000.00"
 */
export function formatCurrency(amount: number): string {
  return `₹${amount.toLocaleString('en-IN', { 
    minimumFractionDigits: 2, 
    maximumFractionDigits: 2 
  })}`
}

